import http from 'hub-http/clients/noAuthApiClient';
import https from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getTemplatesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
export const _fetchTemplates = () => http.get(`${window.location.origin}/forms/templates.json`);
export const getTemplates = () => getFromEarlyRequest(getTemplatesKey(), () => _fetchTemplates());
export const getV2Templates = () => https.get('forms-generation/v1/hubspot-form/templates/availability');